export default __webpack_public_path__ + "static/media/wordsinput_locked_crown.535f6cb9.svg";